export default __webpack_public_path__ + "130b9efe3e5e6755bf19e615a8ce6c5a.png";